// React import
import React from "react";
// Material UI components
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Box, Typography, IconButton } from "@mui/material";
// Internal library imports
import { Button } from "@int-traderjoes/ui-components-library";
// Context imports
import { useTheme } from "@/context";
// Variables
import { getConfirmationTittle, getConfirmationMessage, getHighlightedConfirmationMessage } from "@/components/DataTable/Datatable.variables";
import { getModalPopupStyles, ModalBackgroundStyles } from "@/styles/sx";


interface ConfirmationModalProps {
  open: boolean; // Controls modal visibility
  onClose: () => void; // Function to close the modal
  onConfirm?: (e?: any) => void | Promise<void>; // Function to handle confirm button click
  onDecline?: () => void;
  confirmText?: string; // Text for the confirm button
  cancelText?: string; // Text for the cancel button
  showCancelButton?: boolean; // Optionally display the cancel button
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  onDecline,
  confirmText = "Confirm",
  cancelText = "Cancel",
  showCancelButton = true,
}) => {
  const { darkMode } = useTheme();

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 644,
    bgcolor: darkMode ? "transparent" : "#FFFFFF",
    boxShadow: 24,
  } as const;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p="16px"
          className="bg-TJ-Not-Quite-White dark:bg-TJ-Dark"
        >
          <Typography
            variant="h6"
            sx={getModalPopupStyles(darkMode)}
          >
            {getConfirmationTittle()}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon
              sx={{
                color: darkMode ? "#fff" : "#000",
              }} />
          </IconButton>
        </Box>
        <Typography
          sx={{
            fontFamily: "Cerebri Sans",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "25px",
            color: darkMode ? "#F8F8F2" : "#2C2C2C",
            backgroundColor: darkMode ? "#1E1E1E" : "#FFFFFF",
            paddingY: "16px",
            borderBottom: "1px solid #DEDEDE",
            mx: "16px",
            wordBreak: "break-word",
          
          }}
        >
          {getConfirmationMessage()}
          <span style={{ fontWeight: 600 }}>
            {getHighlightedConfirmationMessage()}
          </span>
        </Typography>
        <Box
          display="flex"
          justifyContent="flex-end"
          px="16px"
          py="24px"
          gap={2}
          sx={ModalBackgroundStyles(darkMode)}
        >
          {showCancelButton && (
            <Button
              className={darkMode ? "dark" : "light"}
              size="large"
              text={cancelText}
              onClick={onDecline}
            />
          )}

          <Button
            className={darkMode ? "dark" : "light"}
            size="large"
            text={confirmText}
            primary
            onClick={(e) => onConfirm?.(e)}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
